<template>
	<div class="clinic-history-topic mb-2" v-if="text || chips.length > 0">
		<p class="mb-1">
			<v-icon v-if="icon == 'symptom'" small color="primary" class="mr-1">mdi-chevron-right</v-icon>
			<v-icon v-if="icon == 'drugs'" small color="primary" class="mr-1">mdi-pill</v-icon>
			<v-icon v-if="icon == 'docs'" small color="primary" class="mr-1">mdi-file-document-outline</v-icon>
			<span class="font-weight-medium">{{title}}</span>
			<template v-if="icon == 'docs'">
				<DocumentItem 
					v-for="document in chips"
					:chip="true"
					:document="document"
					:key="document.id"
				/>
			</template>
			<template v-else>
				<br>
				<span class="font-weight-light" style="white-space: pre-line;">{{text}}</span>
			</template>
			<template v-if="icon == 'drugs'">
				<br v-if="text">
				<DrugItemHistory v-for="(drug,index) in chips" :key="index" :drug="drug" />
			</template>
		</p>
		<p v-if="icon == 'symptom' && chips.length > 0" class="text-body-2 mb-2">
			<v-chip small class="ml-1 mb-1" color="#f2f2f2" v-for="symptom in chips" :key="symptom.code">{{symptom.code}}<span class="mx-1">-</span>{{symptom.title}}</v-chip>
		</p>
		<v-btn v-if="importOption" color="secondary" depressed small class="ml-2 mb-1 primary--text" @click="$emit('import')">
			<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
			<translate>Import</translate>
		</v-btn>
	</div>
</template>

<script>
import DrugItemHistory from "@/components/drugs/DrugItemHistory.vue";
import DocumentItem from "@/components/appointment/anamnesis/DocumentItem.vue";

export default {
	name: "ClinicHistoryTopic",
	props: {
		title: {},
		text: {},
		chips: { default: () => [] },
		icon: { default: "symptom" },
		importOption: { default: false }
	},
	components: {
		DrugItemHistory,
		DocumentItem
	}
};
</script>